import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import EmptyState from '@atlaskit/empty-state';

import { WithPageTitle } from '@/components/primitive/with-page-title';

const IMAGE_SIZE = 180;

const PageNotFound: FC = () => (
  <WithPageTitle title="404" scope="Page Not Found">
    <EmptyState
      header="Page Not Found"
      description={`Sorry, the page you were trying to reach could not be found.
  For further help, reach out to #help-tome on slack.`}
      imageUrl="/static/page-not-found-illustration.svg"
      imageWidth={IMAGE_SIZE}
      maxImageHeight={IMAGE_SIZE}
      maxImageWidth={IMAGE_SIZE}
      primaryAction={
        <Link to="/" relative="path">
          Return to the home page
        </Link>
      }
    />
  </WithPageTitle>
);

export default PageNotFound;
